import React from 'react';
import classes from "./ContactSection.module.css";
import { Col, Container, Row } from 'react-bootstrap';
import SectionHeader from '../../components/SectionHeader';
import { InfoData } from "../../data/app-data";
import Button from '../../components/Button';
import InfoComponent from '../../components/InfoComponent';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { api } from '../../api/api';

export default function ContactSection() {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const onSubmit = async (data) => {
        const payload = {
            token: "ark_consulting",
            to: "no-reply@arkconsultingservices.net",
            // from: "no-reply@shispare.com",
            from: "no-reply@arkconsultingservices.net",
            email: data?.email,
            subject: "Contact Form",
            siteName: "ARK Consulting Services",
            name: data?.name,
            phone: data?.phone,
            text: data?.text
        };
        try {
            const response = await api?.post("/send-email", payload);
            if (response) {
                toast.success('Message Sent Successfully');
            } else {
                toast.error("Message Sending Failed");
            }
        } catch (error) {
            console.log(error);
            toast.error("Message Sending Failed");
        }
        reset();
    };

    return (
        <Container>
            <Row className={`${classes.rowClass}`}>
                <Col md={6}>
                    <SectionHeader className={classes.headingClass} title={"Get in Touch"} heading={`Find Us Here. Make Real
                        Results Happen.`} />
                    {InfoData?.map((e, i) => {
                        return (
                            <InfoComponent data={e} key={i} showTitle={true} />
                        )
                    })}
                </Col>
                <Col md={6}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row className={`gy-3`}>
                            <Col md={12} className={classes.colClass}>
                                <input type="text" placeholder='Name*' className={classes.inputClass} {...register("name", {
                                    required: "Name is required", maxLength: { value: 20, message: "Name should not exceeds 20 characters" }, pattern: {
                                        value: /^[A-Za-z\s]+$/,
                                        message: "Name must contain only alphabets",
                                    },
                                })} />
                                {errors?.name && <span style={{ color: "var(--red)" }}>{errors?.name?.message}</span>}
                            </Col>
                            <Col md={6} sm={6} className={classes.colClass}>
                                <input type="email" placeholder='Email*' className={classes.inputClass} {...register("email", {
                                    required: "Email is required", pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: "Enter a valid email address"
                                    }
                                })} />
                                {errors?.email && <span style={{ color: "var(--red)" }}>{errors?.email?.message}</span>}
                            </Col>
                            <Col md={6} sm={6} className={classes.colClass}>
                                <input
                                    type="number"
                                    placeholder="Phone Number"
                                    className={classes.inputClass}
                                    {...register("phone")}
                                />
                            </Col>
                            <Col md={12} className={classes.colClass}>
                                <input type="text" placeholder='Message*' className={classes.inputClass} {...register("text", {
                                    required: "Message is required", minLength: {
                                        value: 10,
                                        message: "Message must be at least 10 characters long"
                                    },
                                    maxLength: {
                                        value: 200,
                                        message: "Message cannot exceed 200 characters"
                                    }
                                })} />
                                {errors?.text && <span style={{ color: "var(--red)" }}>{errors?.text?.message}</span>}
                            </Col>
                            <Col md={4} className={classes.colClass}>
                                <Button label={"submit"} type={"submit"} variant={"gradient"} />
                            </Col>
                        </Row>
                    </form>
                </Col>
            </Row>
        </Container>
    )
}
